<template>
  <v-container fluid row>
    <v-layout row wrap>
      <v-flex xs10>
        <v-layout row wrap>
          <v-flex
            xs6
            sm6
            class="pa-1"
            v-for="(s, index) in selecteds"
            :key="index"
          >
            <modulo
              :node="modulos[s]"
              @meApague="meApague(s)"
              @meExcluir="meExcluir(s)"
              @meClone="meClone(s)"
            ></modulo>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs2>
        <v-card class>
          <!-- <v-btn
              color="red"
              dark       
                     
              
              style="zoom: 50%; '-moz-transform': 'scale(50%)';height:70px"
              class="pa-0"
              title="Sincronizar Módulos"
              
            >
              <v-icon style='font-size:40px;'>sync</v-icon>
          </v-btn>-->

          <v-btn
            color="red"
            @click="syncAll()"
            v-if="this.dialogsqltf == false"
          >
            <v-icon style="margin-right: 8px;">sync</v-icon>Sincronizar
          </v-btn>

          <v-btn
            color="red"
            @click="syncAllSQL()"
            v-if="this.dialogsqltf == false"
          >
            <v-icon style="margin-right: 8px;">settings_input_composite</v-icon
            >S. SQL
          </v-btn>

          <v-btn
            color="cyan"
            dark
            @click="syncAllBuilder()"
            class="pa-2"
            title="Sincronizar Com SQL"
            v-if="this.dialogsqltf == false"
            >Executar Builder</v-btn
          >

          <v-btn
            color="cyan"
            dark
            small
            @click="syncAllBuilderFast()"
            class="pa-0"
            title="Sincronizar Sem SQL"
            v-if="this.dialogsqltf == false"
            >Fast</v-btn
          >

          <!-- <v-btn
              color="cyan"
              dark              
              @click="syncAllSQL()"
              style="zoom: 50%; '-moz-transform': 'scale(50%)';height:70px"
              class="pa-0"
              title="Sincronizar SQL"
              v-if="this.dialogsqltf==false"
            >
              <v-icon style='font-size:40px;'></v-icon>
          </v-btn>-->

          <v-list subheader light dense>
            <v-btn
              style="margin-right:-30px;"
              color="green"
              dark
              small
              absolute
              top
              right
              fab
              @click="addModulo()"
            >
              <v-icon>add</v-icon>
            </v-btn>

            <v-dialog v-model="dialogsqltf" width="500">
              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title
                  >Sincronia...</v-card-title
                >

                <v-card-text
                  style="text-align:left;"
                  v-html="dialogsql"
                ></v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat @click="dialogsqltf = false"
                    >Fechar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-subheader>Lista de Módulos</v-subheader>
            <span v-for="(item, index) in modulos" :key="index">
              <template v-if="item.json.modulo.builder !== true || 1">
                <v-divider></v-divider>
                <v-list-tile
                  @click="display = index"
                  :class="{
                    ativado: item.json.modulo.mod_active,
                    bemapagado: item.json.modulo.builder == true
                  }"
                >
                  <v-list-tile-content>
                    <v-checkbox
                      v-model="selecteds"
                      :label="item.json.modulo.mod_titulo"
                      :value="index"
                    ></v-checkbox>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </span>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable */


try {
  var rest = require("@/services/metadmin/index").default;
} catch (err) {
  try {
    var rest = require("@/framework/services/metadmin/index")
      .default;
  } catch (err) {}
}



const Modulo = global.reqClass.requirecmpmix("@/admin/metadmin/inc/modulo");

import _ from "lodash";

export default {
  data() {
    return {
      modulos: [],
      selecteds: [],
      display: null,
      show: false,
      dialogsql: "",
      dialogsqltf: false
    };
  },
  methods: {
    async updateRest(module, forcenew = null) {
      if (module == "") return false;

      const json = _.find(this.modulos, el => {
        if (el.json.modulo.mod_tabela == module) {
          el.name = module;
          return true;
        }
        return false;
      });
      const ret = await rest.storeJson(module, json.json);
    },
    meClone(index) {
      let tot = this.modulos.length;
      let copy = _.cloneDeep(this.modulos[index]);
      copy.name = "";
      copy.json.modulo.mod_titulo = "";
      copy.json.modulo.mod_tabela = "";
      copy.json.modulo.builder = false;

      this.modulos.push(copy);

      this.selecteds.push(tot);
    },
    addModulo() {
      let tot = this.modulos.length;
      this.modulos.push({
        name: "",
        json: {
          modulo: {
            mod_titulo: "",
            mod_tabela: "",
            mod_paginacao: "20",
            mod_numero: false,
            mod_active: true,
            tpl: "tabelado",
            tplparam: "",
            mod_secaomen: "",
            rodape: [],
            mod_acao_add: "Adicionar",
            mod_acao_edit: true,
            mod_acao_del: true,
            mod_acao_view: true,
            mod_fn_add: "",
            mod_fn_edit: "",
            mod_fn_del: "",
            mod_fn_view: "",
            mod_fn_flow: "",
            antes: "",
            aomeio: "",
            final: "",
            pre_insert: "",
            pre_update: "",
            pre_delete: "",
            pos_insert: "",
            pos_update: "",
            pos_delete: "",
            mod_lowhere: "",
            mod_lojson: "",
            classe: "",
            classe_display: "",
            classe_display_post: "",
            cache: "",
            exibicao: "nome",
            view_sql: ""
          },
          campos: [
            {
              cmp_titulo: "Código",
              cmp_coluna: "id",
              cmp_dica: "",
              cmp_idioma: "",
              cmp_type: "INT",
              cmp_tamanho: "255",
              cmp_pk: true,
              cmp_add: false,
              cmp_edit: false,
              cmp_view: true,
              cmp_flow: "",
              cmp_extra: "",
              cmp_valida: "",
              cmp_ordena: "",
              cmp_filtro: false,
              cmp_viewmode: null,
              cmp_extra: null,
              cmp_ordem: false,
              cmp_conta: "",
              cmp_showfn: "",
              valorpadrao: null,
              cmp_manual: "",
              cmp_tipo: "text",
              ord: 0,
              cmp_lista: false,
              cmp_join_tabela: "",
              cmp_join_campo: "",
              cmp_join_mostra: "",
              cmp_join_tipo: "select",
              cmp_join_restricao: "",
              cmp_join_tabelann: "",
              cmp_join_tabelac1: "",
              cmp_join_tabelac2: "",
              modulo: "js_secao_texto",
              fotos: null
            }
          ],
          custom: []
        }
      });

      this.selecteds.push(tot);
    },
    meApague(index) {
      this.selecteds = this.selecteds.filter(e => e !== index);
      this.modulos.splice(index, 1);
    },

    async meExcluir(index) {
      if (this.modulos[index].json.modulo.builder == true) return;

      let ret = await rest.dropJson(this.modulos[index].name);
      this.meApague(index);
    },

    async syncAll() {
      this.dialogsql = "";
      this.dialogsqltf = true;
      let ret = await rest.syncAll();
      //console.log(ret)
      this.dialogsql = "<h3>Executado com sucesso!</h3>";
    },

    async syncAllSQL() {
      this.dialogsql = "";
      this.dialogsqltf = true;
      let ret = await rest.syncAllSQL();
      //console.log(ret.data.ok)
      if (ret.data.ok != null && ret.data.ok.length > 0) {
        this.dialogsql = await ret.data.ok.join("<br/><br/>");
      } else {
        this.dialogsql = "<h3>Não há comandos pendentes!</h3>";
      }
    },

    async syncAllBuilder() {
      window.open(global.config.endpoint + "/admin/metadmin/builder/gen");
    },
    async syncAllBuilderFast() {
      window.open(
        global.config.endpoint + "/admin/metadmin/builder/gen?basic=1"
      );
    }
  },
  components: {
    Modulo
  },
  async mounted() {
    this.modulos = (await rest.jsons()).data.lista;
    //console.log(this.modulos);
    global.modulosController = this;
  }
};
</script>

<style scoped>
.ativado {
  background-color: lightgreen;
}
.bemapagado {
  background-color: grey;
  color: #fff;
}
</style>
